import type { Namespace } from './types';
export const zh: Namespace = {
  login: {
    title: '登录',
    username: '用户名',
    usernameRequired: '请输入用户名',
    password: '密码',
    passwordRequired: '请输入密码',
    invalidCredentials: '用户名或密码不正确',
    submit: '登录',
    appName: 'Steam 管理平台',
    productionBadge: '生产环境',
    heroTitle: '订单、账号与兑换\n一处管完',
    heroSubtitle: '统一的 Steam 充值与兑换运营台。',
    version: 'v4.0',
    submitting: '登录中…',
  },
};

export const en: Namespace = {
  login: {
    title: 'Sign in',
    username: 'Username',
    usernameRequired: 'Please enter a username',
    password: 'Password',
    passwordRequired: 'Please enter a password',
    invalidCredentials: 'Incorrect username or password',
    submit: 'Sign in',
    appName: 'Steam Platform',
    productionBadge: 'Production',
    heroTitle: 'Orders, accounts and\nredemption in one place',
    heroSubtitle: 'The operations console for Steam top-up and redemption.',
    version: 'v4.0',
    submitting: 'Signing in…',
  },
};
